import React, { useState, useMemo } from 'react';
import { Download, ArrowUpDown, ChevronDown, ChevronUp, Loader } from 'lucide-react';
import { FaRegFilePdf, FaRegFileWord } from 'react-icons/fa'; 
import { useLanguage } from '../context/LanguageContext';

const PdfNoticeNamune = () => {
  const { language } = useLanguage();
  const [searchTerm, setSearchTerm] = useState('');
  const [sortConfig, setSortConfig] = useState({ key: 'id', direction: 'ascending' });
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 40;

  // The sample list of notices seen in the image
  const initialData = [
    { id: 1, name: 'ध्वजारोहण सुचना pdf - 26 jan 2026', type: 'pdf' },
    { id: 2, name: 'ग्रामसभेची सुचना 26 jan 2026 - pdf (आचारसंहिता असलेल्या जिल्ह्यांसाठी)', type: 'pdf' },
    { id: 3, name: 'ग्रामसभेची सुचना 26 jan 2026 - word (आचारसंहिता असलेल्या जिल्ह्यांसाठी)', type: 'word' },
    { id: 4, name: 'ग्रामसभेची सुचना 26 jan 2026- word (आचारसंहिता नसलेल्या जिल्ह्यांसाठी)', type: 'word' },
    { id: 5, name: 'ग्रामसभेची सुचना 26 jan 2026 - pdf (आचारसंहिता नसलेल्या जिल्ह्यांसाठी)', type: 'pdf' },
    { id: 6, name: 'विशेष ग्रामसभेची सुचना (नोटीस) 26 dec 2025 pdf', type: 'pdf' },
    { id: 7, name: 'विशेष ग्रामसभेची सुचना (नोटीस) 26 dec 2025- word', type: 'word' },
    { id: 8, name: '50% करसवलत नोटीस -घरपट्टी व पाणीपट्टी', type: 'pdf' },
    { id: 9, name: '50 % करसवलत नोटीस--घरपट्टी', type: 'pdf' },
    { id: 10, name: 'Updated - ग्रामसभेची सुचना (नोटीस) nov 2025 pdf', type: 'pdf' },
    { id: 11, name: 'Updated - ग्रामसभेची सुचना (नोटीस) nov 2025 word', type: 'word' },
    { id: 12, name: 'महिला सभेची सुचना (नोटीस) nov 2025', type: 'pdf' },
    { id: 13, name: 'ग्रामसभेची सुचना (नोटीस) 17 sep- 2025', type: 'pdf' },
    { id: 14, name: 'मुख्यमंत्री समृद्ध पंचायतराज अभियान शुभारंभ - निमंत्रणपत्र pdf', type: 'pdf' },
    { id: 15, name: 'ध्वजारोहण सुचना - 17 sep - 2025 pdf- मराठवाडा', type: 'pdf' },
    { id: 16, name: 'ग्रामसभेची सुचना (नोटीस) aug - 2025 pdf', type: 'pdf' },
    { id: 17, name: 'ग्रामसभेची सुचना (नोटीस) aug - 2025 word', type: 'word' },
    { id: 18, name: 'ध्वजारोहण व हर घर तिरंगा सुचना- 13 ते 15 ऑगस्ट 2025', type: 'pdf' },
    { id: 19, name: 'महिला सभेची सुचना (नोटीस) aug 2025', type: 'pdf' },
    { id: 20, name: 'pmay - घरकूल बांधकाम नोटीस', type: 'pdf' },
    { id: 21, name: 'शिवस्वराज्य दिन- जाहीर सूचना - 2025.pdf', type: 'pdf' },
    { id: 22, name: 'ग्रामसभेची सुचना (नोटीस) may 2025 pdf', type: 'pdf' },
    { id: 23, name: 'ग्रामसभेची सुचना (नोटीस) may 2025- word', type: 'word' },
    { id: 24, name: 'ध्वजारोहण सुचना - 1 मे 2025 pdf', type: 'pdf' },
    { id: 25, name: 'PMAY-प्रथम हप्ता वितरण कार्यक्रम ग्रा.पं स्तर- निमंत्रणपत्र दि.22 फेब्रुवारी 2025', type: 'pdf' },
    { id: 26, name: 'ध्वजारोहण निमंत्रण पत्र - 26 jan 2025', type: 'pdf' },
    { id: 27, name: 'ग्रामसभेची सुचना pdf 26 जानेवारी 2025', type: 'pdf' },
    { id: 28, name: 'ग्रामसभेची सुचना word- 26 जानेवारी 2025', type: 'word' },
    { id: 29, name: 'GPDP 2024-25 - 4 सभा नोटीस pdf', type: 'pdf' },
    { id: 30, name: 'GPDP 2024-25 - 4 सभा नोटीस word', type: 'word' },
    { id: 31, name: 'ग्रामसभेची सूचना (नोटीस) नोव्हेंबर 2024 pdf', type: 'pdf' },
    { id: 32, name: 'ग्रामसभेची सूचना (नोटीस) नोव्हेंबर 2024 word', type: 'word' },
    { id: 33, name: 'शिपाई भरती जाहिरात', type: 'pdf' },
    { id: 34, name: 'मासिक सभेची सुचना (नोटीस) -कोकण', type: 'pdf' },
    { id: 35, name: 'मासिक सभेची सुचना (नोटीस) - 5 sub pdf', type: 'pdf' },
    { id: 36, name: 'मासिक सभेची सुचना (नोटीस) - 5 sub word', type: 'word' },
    { id: 37, name: 'मासिक सभेची सुचना (नोटीस) - 4 sub', type: 'pdf' },
    { id: 38, name: 'मासिक सभेची सुचना (नोटीस) - 1 sub pdf', type: 'pdf' },
    { id: 39, name: 'महिला सभेची सुचना (नोटीस) blank pdf', type: 'pdf' },
    { id: 40, name: 'महिला सभेची सुचना (नोटीस) blank word', type: 'word' },
    { id: 41, name: 'फेरआकारणी नोटीस (दराबाबत)', type: 'pdf' },
    { id: 42, name: 'फेरआकारणी नोटीस (आकारणीयादीबाबत)', type: 'pdf' },
    { id: 43, name: 'प्लास्टिक बंदी नोटीस', type: 'pdf' },
    { id: 44, name: 'प्रसिध्दी पत्रक फेरफार', type: 'pdf' },
    { id: 45, name: 'पावसाळ्यातील काळजी- जाहीर प्रगटन', type: 'pdf' },
    { id: 46, name: 'नोटीस- ग्रामसमृद्धी दिवस', type: 'pdf' },
    { id: 47, name: 'घरकुल बांधकाम नोटीस', type: 'pdf' },
    { id: 48, name: 'ग्रामसभेची सुचना (नोटीस) blank word', type: 'word' },
    { id: 49, name: 'ग्रामसभेची सुचना (नोटीस) blank pdf', type: 'pdf' },
    { id: 50, name: 'कर्मचारी नोटीस', type: 'pdf' },
    { id: 51, name: 'अनाधिकृत होर्डिंग्ज नोटीस', type: 'pdf' },
    { id: 52, name: 'अतिक्रमण नोटीस', type: 'pdf' },
    { id: 53, name: 'ध्वजारोहण सुचना - 17 sep - 2024', type: 'pdf' },
    { id: 54, name: 'ग्रामसभेची सुचना (नोटीस) aug - 2024- word', type: 'word' },
    { id: 55, name: 'ग्रामसभेची सुचना (नोटीस) aug - 2024- pdf', type: 'pdf' },
    { id: 56, name: 'महिला सभेची सुचना (नोटीस) aug 2024', type: 'pdf' },
    { id: 57, name: 'शिवस्वराज्य दिन- जाहीर सुचना - 2024', type: 'pdf' },
    { id: 58, name: 'ग्रामसभेची सुचना (नोटीस) may 2024 pdf', type: 'pdf' },
    { id: 59, name: 'ग्रामसभेची सुचना (नोटीस) may 2024 word', type: 'word' },
    { id: 60, name: 'महिला सभेची सुचना (नोटीस) may 2024 pdf', type: 'pdf' },
    { id: 61, name: 'ध्वजारोहण सुचना - 26 jan 2024 pdf', type: 'pdf' },
    { id: 62, name: 'ALL IN ONE FILE- पुण्यश्लोक अहिल्यादेवी होळकर महिला सन्मान पुरस्कार 2023', type: 'pdf' },
    { id: 63, name: 'वार्ड सभेची सुचना (नोटीस) नमुना', type: 'pdf' },
    { id: 64, name: 'मागणीच्या लेखाचा नमुना (रिट)', type: 'pdf' },
    { id: 65, name: 'जप्तीचे अधिपत्र (नोटीस)', type: 'pdf' },
    { id: 66, name: 'अविश्वास ठराव नोटीस', type: 'pdf' },
    { id: 67, name: 'राजीनामा/ राजीनाम्याची नोटीस', type: 'pdf' },
  ];

  const [generatingId, setGeneratingId] = useState(null);

  const handleSort = (key) => {
    let direction = 'ascending';
    if (sortConfig.key === key && sortConfig.direction === 'ascending') {
      direction = 'descending';
    }
    setSortConfig({ key, direction });
  };

  const filteredData = useMemo(() => {
    let sortableItems = [...initialData];

    if (searchTerm) {
      sortableItems = sortableItems.filter((item) =>
        item.name.toLowerCase().includes(searchTerm.toLowerCase()) || 
        item.id.toString().includes(searchTerm)
      );
    }

    if (sortConfig !== null) {
      sortableItems.sort((a, b) => {
        if (a[sortConfig.key] < b[sortConfig.key]) {
          return sortConfig.direction === 'ascending' ? -1 : 1;
        }
        if (a[sortConfig.key] > b[sortConfig.key]) {
          return sortConfig.direction === 'ascending' ? 1 : -1;
        }
        return 0;
      });
    }

    return sortableItems;
  }, [initialData, searchTerm, sortConfig]);

  // Pagination logic
  const totalPages = Math.ceil(filteredData.length / itemsPerPage);
  const paginatedData = filteredData.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  const SortIcon = ({ columnKey }) => {
    if (sortConfig.key !== columnKey) {
      return <ArrowUpDown className="w-4 h-4 text-gray-300 mx-1 inline" />;
    }
    return sortConfig.direction === 'ascending' 
      ? <ChevronUp className="w-4 h-4 text-gray-500 mx-1 inline" /> 
      : <ChevronDown className="w-4 h-4 text-gray-500 mx-1 inline" />;
  };

  const generatePDF = async (item) => {
    if (item.id === 1) {
      window.open('/dhvajarohan-suchana-26jan2026-form', '_blank');
      return;
    }
    
    if (item.id === 2) {
      window.open('/gramsabha-notice-aacharsanhita-form', '_blank');
      return;
    }

    if (item.id === 3) {
      window.open('/gramsabha-notice-aacharsanhita-word-form', '_blank');
      return;
    }

    if (item.id === 4) {
      window.open('/gramsabha-notice-no-aacharsanhita-word-form', '_blank');
      return;
    }

    if (item.id === 5) {
      window.open('/gramsabha-notice-no-aacharsanhita-pdf-form', '_blank');
      return;
    }

    if (item.id === 6) {
      window.open('/special-gramsabha-notice-26dec2025-form', '_blank');
      return;
    }
    
    setGeneratingId(item.id);
    // Simulate loading for now since actual files aren't linked yet
    setTimeout(() => {
      setGeneratingId(null);
      alert(language === 'marathi' ? `${item.name} डाउनलोड लवकरच उपलब्ध होईल!` : `${item.name} download will be available soon!`);
    }, 1000);
  };

  return (
    <div className="min-h-screen bg-gray-100 flex flex-col font-sans">
      <main className="flex-grow py-8 px-4 sm:px-6 lg:px-8">
        <div className="max-w-6xl mx-auto">
          {/* Main Card Container */}
          <div className="bg-white shadow-xl rounded-lg border border-gray-200 overflow-hidden">
            
            {/* Header Title Bar */}
            <div className="bg-[#fff1c9] border-b border-[#e5d4a1] py-2 px-4 flex justify-between items-center gap-2">
              <h2 className="text-[#000080] text-[15px] sm:text-xl font-bold flex items-center ">
            {/* Custom dark blue multi-pointed star as in the image */}
                <svg className="w-5 h-5 mr-3 text-[#000080] fill-current" viewBox="0 0 24 24">
                   <path d="M12 2l2.4 2.4L18 3.5l1.5 3.3 3.5.9-1.2 3.2 2.2 2.6-2.2 2.6 1.2 3.2-3.5.9-1.5 3.3-3.6-1.1L12 22l-2.4-2.4L6 20.5l-1.5-3.3-3.5-.9 1.2-3.2-2.2-2.6 2.2-2.6-1.2-3.2 3.5-.9 1.5-3.3 3.6 1.1z"/>
                </svg>
                {language === 'marathi' ? 'नोटीस नमुने' : 'Notice Forms'}
          </h2>
          <button onClick={() => window.history.back()} className="bg-gray-200 hover:bg-gray-300 text-gray-800 font-bold py-1 px-4 rounded text-sm no-print whitespace-nowrap shrink-0">
                  {language === 'marathi' ? 'मागे जा' : 'Back'}
                </button>
            </div>

            {/* Search Bar */}
            <div className="flex justify-end bg-white py-3 px-4 border-b border-gray-200">
              <div className="flex items-center">
                <label className="text-gray-600 mr-2 text-sm font-medium">Search:</label>
                <input
                  type="text"
                  className="border border-gray-300 rounded px-2 py-1 text-sm focus:outline-none focus:border-[#337ab7] focus:ring-1 focus:ring-[#337ab7] w-48"
                  value={searchTerm}
                  onChange={(e) => {
                    setSearchTerm(e.target.value);
                    setCurrentPage(1); // Reset page on search
                  }}
                />
              </div>
            </div>

            {/* Table Container for responsiveness */}
            <div className="overflow-x-auto">
              <table className="w-full text-left border-collapse min-w-[700px]">
                <thead>
                  <tr className="bg-[#fdfdfd] border-b-2 border-gray-200 shadow-sm">
                    <th 
                      className="py-3 px-4 border-r border-gray-100 font-bold text-[#00008b] text-sm cursor-pointer hover:bg-gray-50 transition-colors whitespace-nowrap"
                      onClick={() => handleSort('id')}
                      style={{ width: '80px' }}
                    >
                      <div className="flex items-center justify-between">
                         <span>{language === 'marathi' ? 'नं' : 'No'}</span>
                         <SortIcon columnKey="id" />
                      </div>
                    </th>
                    <th 
                      className="py-3 px-4 border-r border-gray-100 font-bold text-[#00008b] text-sm cursor-pointer hover:bg-gray-50 transition-colors"
                      onClick={() => handleSort('name')}
                    >
                      <div className="flex items-center justify-between">
                         <span>{language === 'marathi' ? 'नाव' : 'Name'}</span>
                         <SortIcon columnKey="name" />
                      </div>
                    </th>
                    <th className="py-3 px-4 border-r border-gray-100 font-bold text-[#00008b] text-sm text-center w-32 cursor-pointer hover:bg-gray-50 transition-colors">
                       <div className="flex items-center justify-center space-x-1">
                         <span>{language === 'marathi' ? 'प्रकार' : 'Type'}</span>
                         <ArrowUpDown className="w-4 h-4 text-gray-300 ml-1 inline" />
                       </div>
                    </th>
                    <th className="py-3 px-4 font-bold text-[#00008b] text-sm text-center w-48 cursor-pointer hover:bg-gray-50 transition-colors">
                       <div className="flex items-center justify-center space-x-1">
                         <span>{language === 'marathi' ? 'डाऊनलोड करा' : 'Download'}</span>
                         <ArrowUpDown className="w-4 h-4 text-gray-300 ml-1 inline" />
                       </div>
                    </th>
                  </tr>
                </thead>
                <tbody className="bg-white">
                  {paginatedData.length > 0 ? (
                    paginatedData.map((item, index) => (
                      <tr 
                         key={item.id} 
                         className={`border-b border-gray-200 hover:bg-[#f8fafc] transition-colors ${index % 2 === 0 ? 'bg-[#fbfbfb]' : 'bg-white'}`}
                      >
                        <td className="py-2.5 px-4 text-sm text-[#000080] border-r border-gray-100 text-left font-medium">
                          {item.id}
                        </td>
                        <td className="py-2.5 px-4 text-sm text-[#4a729e] border-r border-gray-100">
                          {item.name}
                        </td>
                        <td className="py-2.5 px-4 text-center border-r border-gray-100">
                          {item.type === 'word' ? (
                             <FaRegFileWord className="w-5 h-5 text-[#000080] mx-auto opacity-75" />
                          ) : (
                             <FaRegFilePdf className="w-5 h-5 text-[#000080] mx-auto opacity-75" />
                          )}
                        </td>
                        <td className="py-2.5 px-4 text-center">
                          <button 
                            onClick={() => generatePDF(item)}
                            disabled={generatingId === item.id}
                            className={`text-white text-xs px-3 py-1.5 rounded-sm flex items-center justify-center mx-auto space-x-1 shadow-sm transition-all flex-nowrap w-36 ${
                              generatingId === item.id 
                                ? 'bg-gray-500 cursor-not-allowed' 
                                : 'bg-[#00a65a] hover:bg-[#008d4c]'
                            }`}
                          >
                            {generatingId === item.id ? (
                               <Loader className="w-3.5 h-3.5 animate-spin" />
                            ) : (
                               <Download className="w-3.5 h-3.5" />
                            )}
                            <span className="font-semibold whitespace-nowrap">
                              {generatingId === item.id ? 'Loading...' : 'View/Download'}
                            </span>
                          </button>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="4" className="py-6 text-center text-gray-500">
                        {language === 'marathi' ? 'कोणतीही नोटीस सापडली नाही.' : 'No notices found.'}
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>

            {/* Pagination Controls */}
            {totalPages > 1 && (
              <div className="flex justify-end items-center bg-gray-50 px-4 py-3 border-t border-gray-200">
                <div className="flex space-x-1 shadow-sm">
                  <button 
                    onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
                    disabled={currentPage === 1}
                    className="bg-white border border-gray-300 text-gray-700 hover:bg-gray-50 px-3 py-1 text-sm rounded-l-sm disabled:opacity-50 disabled:cursor-not-allowed"
                  >
                    Previous
                  </button>
                  
                  {/* Dynamically generate page numbers */}
                  {[...Array(totalPages)].map((_, i) => (
                    <button
                      key={i + 1}
                      onClick={() => setCurrentPage(i + 1)}
                      className={`${
                        currentPage === i + 1 
                        ? 'bg-[#337ab7] text-white border-[#337ab7]' 
                        : 'bg-white text-gray-700 border-gray-300 hover:bg-gray-50'
                      } border-y border-r px-3 py-1 text-sm`}
                    >
                      {i + 1}
                    </button>
                  ))}

                  <button 
                    onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))}
                    disabled={currentPage === totalPages || totalPages === 0}
                    className="bg-white border-y border-r border-gray-300 text-[#337ab7] hover:bg-gray-50 px-3 py-1 text-sm rounded-r-sm disabled:opacity-50 disabled:cursor-not-allowed"
                  >
                    Next
                  </button>
                </div>
              </div>
            )}

          </div>
        </div>
      </main>
    </div>
  );
};

export default PdfNoticeNamune;
